import {
  CustomPromotionSectionDoc,
  ProductGroupForCategorySubsetDoc,
  PromotionSection,
  PromotionSectionDoc,
  StoreCategory,
} from '@gooduncles/gu-app-schema';
import { useCallback } from 'react';
import { deleteTimestamp } from 'src/utils/firebase/firebase-short-cut';

import {
  setCustomPromotionSections,
  setIsMenuOpen,
  setProductGroupForCategories,
  setPromotionSections,
  setSelectedStoreCategory,
} from '../slices/home';
import { useAppDispatch } from '../store';

const useHomeConf = () => {
  const dispatch = useAppDispatch();

  const onSetSelectedStoreCategory = useCallback(
    (selectedStoreCategory: StoreCategory) => {
      dispatch(setSelectedStoreCategory(selectedStoreCategory));
    },
    [dispatch]
  );

  const onSetProductGroupForCategories = useCallback(
    (docs: ProductGroupForCategorySubsetDoc[]) => {
      // Redux state에는 _timeCreate, _timeUpdate를 저장하지 않는다.
      const categories = Object.fromEntries(docs.map((doc) => [doc._id, deleteTimestamp(doc)]));
      dispatch(setProductGroupForCategories(categories));
    },
    [dispatch]
  );

  const onSetIsMenuOpen = useCallback(
    (isMenuOpen: boolean) => {
      dispatch(setIsMenuOpen(isMenuOpen));
    },
    [dispatch]
  );

  const onSetPromotionSections = useCallback(
    (promotionSections0: PromotionSectionDoc[]) => {
      // Redux state에는 _timeCreate, _timeUpdate를 저장하지 않는다.
      const promotionSections: PromotionSection[] = promotionSections0.map((promotionSection) =>
        deleteTimestamp(promotionSection)
      );
      dispatch(setPromotionSections(promotionSections));
    },
    [dispatch]
  );

  const onSetCustomPromotionSections = useCallback(
    (customPromotionSections0: CustomPromotionSectionDoc[]) => {
      const customPromotionSections: CustomPromotionSectionDoc[] = customPromotionSections0.map((section) =>
        deleteTimestamp(section)
      );
      dispatch(setCustomPromotionSections(customPromotionSections));
    },
    [dispatch]
  );

  return {
    onSetSelectedStoreCategory,
    onSetProductGroupForCategories,
    onSetIsMenuOpen,
    onSetPromotionSections,
    onSetCustomPromotionSections,
  };
};

export default useHomeConf;
